import React from 'react';
import './PharmaciesNetwork.css';
import SectionTitle from '../SectionTitle/SectionTitle';
import Map from '../Map/Map';

const PharmaciesNetwork = () => {
  return (
    <div>
      <div className="PharmaciesNetwork__title">
        <SectionTitle>
          Trouver
          <strong className="SectionTitle__item--bold">
            &nbsp;votre pharmacie
          </strong>
        </SectionTitle>
      </div>
      <Map />
    </div>
  );
};

export default PharmaciesNetwork;
